export var TipLevels;
(function (TipLevels) {
    TipLevels["ERROR"] = "ERROR";
    TipLevels["WARNING"] = "WARNING";
    TipLevels["TIP"] = "TIP";
})(TipLevels || (TipLevels = {}));
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/validators/dist/types.js
// module id = 1616
// module chunks = 118